// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.additional-top-margin[data-v-37ccac67]{margin-top:10px}`, "",{"version":3,"sources":["webpack://./src/components/ConversationSettings/ListableSettings.vue"],"names":[],"mappings":"AACA,wCACC,eAAA","sourcesContent":["\n.additional-top-margin {\n\tmargin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
